import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Icon } from 'antd';
import { FontSizeOutlined, DeleteOutlined } from '@ant-design/icons';

import { articleContentType } from 'common/constants/content';

import Image from './image';
import Text from './text';
import Video from './video';

import useStyles from './style';

const Main = ({ activeIndex, data, handleValueChange, handleFocus, handleRemoveClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <For of={data} each="item" index="idx">
        <div
          className={classNames(classes.contentItem, {
            [classes.contentItemFocused]: activeIndex === idx,
            [classes.contentItemTitle]: item.type === articleContentType.TITLE,
            [classes.contentItemOthers]: item.type !== articleContentType.TITLE,
          })}
          key={`${item.type}-${item.index}-${idx}`}
        >
          <If condition={activeIndex === idx}>
            <div className={classes.label}>
              <Choose>
                <When condition={item.type === articleContentType.IMAGE}>
                  <Icon type={'picture'} />
                </When>
                <When condition={item.type === articleContentType.VIDEO}>
                  <Icon type="video-camera" />
                </When>
                <Otherwise>
                  <FontSizeOutlined />
                </Otherwise>
              </Choose>
              <span className={classes.labelText}>
                {t(`content.article_content_type.${item?.type?.toLowerCase()}`)}
              </span>
            </div>

            <If condition={!(item.type === articleContentType.TITLE && item.index === 1)}>
              <div className={classes.addonAfter}>
                <div className={classes.removeIcon} onClick={handleRemoveClick}>
                  <DeleteOutlined />
                </div>
              </div>
            </If>
          </If>
          <div className={classes.content} onClick={() => handleFocus(idx)}>
            <Choose>
              <When condition={item.type === articleContentType.IMAGE}>
                <Image value={item} onChange={handleValueChange} />
              </When>
              <When condition={item.type === articleContentType.VIDEO}>
                <Video value={item} onChange={handleValueChange} />
              </When>
              <Otherwise>
                <Text
                  value={item}
                  onChange={handleValueChange}
                  autoFocus={item.type === articleContentType.TITLE && item.index === 1}
                />
              </Otherwise>
            </Choose>
          </div>
        </div>
      </For>
    </div>
  );
};

export default Main;
